<template>
    <div class="table-responsive">
        <el-table border :data="data" style="width:100%" class="el-table-css" :row-class-name="rowClass">
            <!-- Subrogation number with link -->
            <el-table-column prop="subrogationNumber" label="Subroqasiya №" width="140">
                <template #default="s">
                    <a href="javascript:void(0)" style="color:#409eff;text-decoration:underline"
                        @click="openSubrogation(s.row.subrogationId)">
                        {{ s.row.subrogationNumber }}
                    </a>
                </template>
            </el-table-column>
            <el-table-column prop="statusName" label="Status" width="280"/>
            <el-table-column prop="description" label="Təsvir">
                <template #default="s">{{ s.row.description || '-' }}</template>
            </el-table-column>
            <el-table-column label="Status tarixi" width="180">
                <template #default="s">{{ formatDate(s.row.statusDate) }}</template>
            </el-table-column>
            <el-table-column label="KPI son tarix" width="180">
                <template #default="s">{{ formatDate(s.row.kpiDueDate) }}</template>
            </el-table-column>
            <el-table-column prop="overdueDays" style="text-align: center !important ;" label="Gecikmə günü" width="150">
                <template #default="s">
                    <el-tag :type="tagType(s.row.overdueDays)" effect="dark">
                        {{ s.row.overdueDays }}
                    </el-tag>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: { data: Array },
    methods: {
        formatDate(d) {
            if (!d) return '';
            const x = new Date(d);
            return `${x.getDate().toString().padStart(2, '0')}.` +
                `${(x.getMonth() + 1).toString().padStart(2, '0')}.` +
                x.getFullYear();
        },
        openSubrogation(id) {
            const r = this.$router.resolve({ name: 'Subroqasiya - Məlumat', params: { id } });
            window.open(r.href, '_blank');
        },
        rowClass({ row }) {
            const o = row.overdueDays;
            if (o >= 25) return 'row-danger';      // 21+
            if (o >= 20) return 'row-warning';     // 11-20
            if (o >= 0) return 'row-success';     // 0-10
            return '';                             // ещё не просрочено
        },
        tagType(o) {
            if (o >= 25) return 'danger';   // красный
            if (o >= 20) return 'warning';  // оранжевый
            if (o >= 0) return 'success';  // зелёный
            return '';
        }
    }
};
</script>
<style scoped>
/* 0-19 дней — мягкий жёлтый */
.row-success td { background:#fffbe6; color:#b45309; }

/* 20-24 дней — оранжевый */
.row-warning td { background:#fff2cc; color:#b45309; }

/* 25+ дней — красный */
.row-danger  td { background:#fdecea; color:#b91c1c; }

/* Перекрашиваем «success»-тэг Element Plus в жёлтый,
   чтобы он совпадал с нашей строкой 0-19 дней */
.el-tag--success {
  background-color:#ffecb3 !important;
  border-color:#ffecb3 !important;
  color:#b45309 !important;
}
</style>
